
import { systemHistoryActivityListAPI } from '@/api/common';
import { crmDownImportErrorAPI } from '@/api/crm/common';

import { downloadExcelWithResData } from '@/utils/index';

export default {
  // 导入历史
  name: 'CRMImportHistory',
  components: {},
  // filters: {
  //   createTime(time) {
  //     const times = time.split(' ')
  //     return times.length > 0 ? times[0] : ''
  //   }
  // },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    // CRM类型
    crmType: {
      type: String,
      default: ''
    },
    // moduleType
    props: Object
  },
  data: function data() {
    return {
      loading: false,
      tableList: []
    };
  },

  computed: {},
  watch: {
    show: function show(value) {
      if (value) {
        this.getList();
      }
    }
  },
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {},

  methods: {
    getList: function getList() {
      var _this = this;

      this.loading = true;
      systemHistoryActivityListAPI({
        page: 1,
        limit: 9999,
        type: 'crm_' + this.crmType
        // type: {
        //   customer: 14,
        //   contacts: 16,
        //   leads: 18,
        //   product: 20
        // }[this.crmType] || this.props.moduleType
      }).then(function (res) {
        _this.loading = false;
        _this.tableList = res.data.list;
      }).catch(function () {
        _this.loading = false;
      });
    },


    /**
     * 下载错误数据
     */
    downloadError: function downloadError(path) {
      crmDownImportErrorAPI({ path: path, name: '导入错误数据' }).then(function (res) {
        downloadExcelWithResData(res);
      }).catch(function () {});
    },
    getImportContent: function getImportContent(totalSize, content) {
      // const list = content.split(',') || []
      // const updateSize = Number(list[1] || '0')
      // const errSize = Number(list[0] || '0')
      // return `覆盖${updateSize}条，导入成功${totalSize - errSize}条，导入失败${errSize}条。`
    },


    /**
     * 获取错误数据数
     */
    getErrorNum: function getErrorNum(content) {
      var list = content.split(',') || [];
      var errSize = Number(list[0] || '0');
      return parseInt(errSize);
    },


    /**
     * 关闭
     */
    closeClick: function closeClick() {
      this.$emit('close');
    }
  }
};